import React, { useEffect, useRef } from "react";
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,
} from "./HeroElements";
import Video from "../../videos/bgvideo.mp4";
import "../../App.css";

const HeroSection = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Ensure video plays on mobile and Safari
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.log("Video autoplay prevented:", error);
      });
    }
  }, []);

  return (
    <HeroContainer>
      <HeroBg>
        <VideoBg
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          webkit-playsinline="true"
          src={Video}
          type="video/mp4"
        />
      </HeroBg>
      <HeroContent>
        <h1 className="h1-hero">Building Digital Solutions That Matter</h1>
        <p className="hero-text">
          We craft stunning websites and powerful applications that help your business grow.
          Let's bring your vision to life.
        </p>
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection;
